import { clearSsoCookies } from '../../tokens/cookies';
import { removeAccessAndIdTokens } from '../../tokens/localStorage';
import type { SsoConfig } from '../types';

export const buildSignInUrl = (config: SsoConfig): string =>
  `${config.idServerBaseSignIn}?app_id=${config.appID}`;

export const buildSignOutUrl = (config: SsoConfig): string =>
  `${config.idServerBase}/logout?app_id=${config.appID}`;

const isCypressRuntime = () =>
  typeof window !== 'undefined' &&
  Boolean((window as Window & { Cypress?: unknown }).Cypress);

export const redirectToSignIn = (config: SsoConfig) => {
  if (isCypressRuntime()) {
    return;
  }

  removeAccessAndIdTokens();
  window.location.href = buildSignInUrl(config);
};

export const redirectToSignOut = (config: SsoConfig) => {
  if (isCypressRuntime()) {
    return;
  }

  localStorage.clear();
  clearSsoCookies(config.apiEnv);
  window.location.href = buildSignOutUrl(config);
};
